import { Banner } from '@sunwebgroup/uds-ui/banner'
import { useIntl } from '@/intl'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { BookingDetailsSection } from './BookingDetailsSection'
import { DocumentCard } from './DocumentCard'
import styles from './DocumentsSection.module.css'

export function DocumentsSection() {
  const { formatMessage } = useIntl()
  const { items: documents, loadStatus } = useBookingDetailsStore(state => state.documents)

  const renderContent = () => {
    if (loadStatus === 'error') {
      return (
        <div className={styles.statusContainer}>
          <Banner
            color="danger"
            size="M"
            hasIcon
            contentIsCentered
          >
            <Banner.Text>{formatMessage({ id: 'booking_details_documents_error_text' })}</Banner.Text>
          </Banner>
        </div>
      )
    }

    if (loadStatus === 'success' && documents.length === 0) {
      return (
        <div>
          <Banner
            color="informative"
            size="M"
            hasIcon
            contentIsCentered
          >
            <Banner.Text>{formatMessage({ id: 'booking_details_documents_empty_text' })}</Banner.Text>
          </Banner>
        </div>
      )
    }

    return (
      <div className={styles.grid}>
        {documents.map(document => (
          <DocumentCard key={document.url} document={document} />
        ))}
      </div>
    )
  }

  return (
    <BookingDetailsSection
      iconName="Documents"
      title={formatMessage({ id: 'booking_details_documents_title' })}
      description={formatMessage({ id: 'booking_details_documents_subtitle' })}
    >
      {renderContent()}
    </BookingDetailsSection>
  )
}
